import { Business, MobileFriendly, Person, Help } from '@material-ui/icons';
import { Role } from 'app/client/appUsers/models/appUsersModels';
import React, { FC } from 'react';

interface ImageUserTypeProps {
  role: Role | null;
  className?: string;
  key?: string;
}

const ImageUserType: FC<ImageUserTypeProps> = ({ role, className = '', key }) => {
  return (
<div className={`flex w-auto relative mb-2 ${className}`} key={key}>
      <Person
        style={{
          fontSize: 'clamp(80px, 15vw, 120px)',
          color: `${
            role === Role.CORPORATE
              ? '#ff8700'
              : role === Role.PARTICULAR
              ? '#3a77ff'
              : '#ABABAB'
          }`,
          marginBottom: '0.5rem',
          borderRadius: '50%',
          padding: '5px',
          boxShadow: `${
            role === Role.CORPORATE
              ? '0 4px 4px rgba(255,135,0,0.5)'
              : role === Role.PARTICULAR
              ? '0 4px 4px rgba(58,119,255,0.5)'
              : '0 4px 4px rgba(170,170,170,0.5)'
          }`
        }}
      />
      {role === Role.CORPORATE ? (
        <Business
          style={{
            fontSize: 'clamp(30px, 5vw, 60px)',
            color: '#3a77ff', // Verde
            position: 'absolute',
            right: -20,
            bottom: 80,
            backgroundColor: 'white',
            borderRadius: '50%',
            padding: '4px',
            boxShadow: '0 4px 4px rgba(58,119,255,0.5)'
          }}
        />
      ) : role === Role.PARTICULAR ? (
        <MobileFriendly
          style={{
            fontSize: 'clamp(30px, 5vw, 50px)',
            color: '#10B981', // Verde
            position: 'absolute',
            right: -10,
            bottom: -4,
            backgroundColor: 'white',
            borderRadius: '50%',
            padding: '4px',
            boxShadow: '0 4px 4px rgba(16,185,129,0.5)'
          }}
        />
      ) : (
        <Help
          style={{
            fontSize: 'clamp(30px, 5vw, 50px)',
            color: '#0270AB', // Verde
            position: 'absolute',
            right: -10,
            bottom: -4,
            backgroundColor: 'white',
            borderRadius: '50%',
            padding: '4px',
            boxShadow: '0 4px 4px rgba(97,255,208,0.5)'
          }}
        />
      )}
    </div>
  );
};

export default ImageUserType;
